import React from 'react';
import './ChatsTab.css';

const ChatsTab = ({
    chats,
    selectedChat,
    messages,
    newMessage,
    isSending,
    messagesEndRef,
    chatMessagesRef,
    handleChatSelection,
    handleCloseChat,
    handleSendMessage,
    setNewMessage,
    formatDate
}) => {
    return (
        <div className="admin-chat-container">
            <div className="chats-list">
                {chats.length === 0 ? (
                    <div className="empty-chats">
                        <p>No active chats available</p>
                    </div>
                ) : (
                    chats.map(chat => (
                        <div 
                            key={chat.id} 
                            className={`chat-item ${selectedChat?.id === chat.id ? 'active' : ''}`}
                            onClick={() => handleChatSelection(chat)}
                        >
                            <div className="chat-item-name">
                                {chat.userName || 'Anonymous User'}
                                {chat.unreadByAdmin > 0 && (
                                    <span className="unread-badge">{chat.unreadByAdmin}</span>
                                )}
                            </div>
                            <div className="chat-item-time">
                                {formatDate(chat.lastMessageTime)}
                            </div>
                        </div>
                    ))
                )}
            </div>
            
            <div className="chat-detail">
                {selectedChat ? (
                    <>
                        <div className="chat-header">
                            <h3>{selectedChat.userName || 'Anonymous User'}</h3>
                        </div>
                        
                        <div className="chat-messages admin-view" ref={chatMessagesRef}>
                            {messages.length === 0 ? (
                                <div className="empty-chat">
                                    <p>No messages yet. Start the conversation!</p>
                                </div>
                            ) : (
                                messages.map(message => (
                                    <div 
                                        key={message.id} 
                                        className={`message ${message.senderId === 'admin' ? 'admin' : 'user'}`}
                                    >
                                        <div className="message-content">
                                            <p>{message.text}</p>
                                            <span className="message-time">
                                                {formatDate(message.timestamp)}
                                            </span>
                                        </div>
                                    </div>
                                ))
                            )}
                            <div ref={messagesEndRef} />
                        </div>
                        
                        <form className="chat-input-form" onSubmit={handleSendMessage}>
                            <input
                                type="text"
                                value={newMessage}
                                onChange={(e) => setNewMessage(e.target.value)}
                                placeholder="Type your message here..."
                                disabled={isSending}
                            />
                            <button type="submit" disabled={!newMessage.trim() || isSending}>
                                {isSending ? 'Sending...' : 'Send'}
                            </button>
                        </form>
                        
                    </>
                ) : (
                    <div className="no-chat-selected">
                        <p>Select a chat from the list to view the conversation</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ChatsTab; 